'use client';
import * as React from 'react';
const AccordionItemContext = React.createContext(undefined);
const accordionItemContextDefaultValue = {
    open: false,
    disabled: false,
    value: undefined,
    onHeaderClick () {
    /* noop */ }
};
export const { Provider: AccordionItemProvider } = AccordionItemContext;
export const useAccordionItemContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(AccordionItemContext)) !== null && _React_useContext !== void 0 ? _React_useContext : accordionItemContextDefaultValue;
};
